<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>运营</el-breadcrumb-item>
        <el-breadcrumb-item to="/template/list">群发任务</el-breadcrumb-item>
        <el-breadcrumb-item>添加群发任务</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">添加群发任务</h2>
        </div>
      </div>
    </div>
    <div
      class="card"
      style="margin-top: 20px;"
    >
      <el-alert
        title="定时任务: 为保障用户良好的接受短信体验，仅接受8:00-22:00时间区间的定时发送任务，请谅解！"
        type="error"
        show-icon
        style="background-color:#ECF2FE ;"
      >
      </el-alert>
      <div class="main">
        <div class="form">
          <el-form
            class="search-wrap"
            ref="formRules"
            :model="dataForm"
            :rules="rules"
            label-width="150px"
            label-position="left"
          >
            <el-form-item
              label="任务名称"
              prop="TemplateName"
            >
              <el-input
                v-model="dataForm.name"
                placeholder="支持中文、英文、数字、下划线，不超过30个字符"
                style="width: 582px;"
                :maxlength="30"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item
              label="短信签名"
              prop="sign_name"
            >
              <el-select
                v-model="dataForm.sign_name"
                placeholder="请选择"
                style="width: 582px;"
              >
                <el-option
                  v-for="item in smsSignList"
                  :key="item.SignName"
                  :label="item.SignName"
                  :value="item.SignName"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="短信模板"
              prop="template_code"
            >
              <el-select
                v-model="TemplateType"
                placeholder="请选择"
                style="width: 220px;"
                @change="fetchTemplateList"
              >
                <el-option
                  value=""
                  label="全部"
                >
                </el-option>
                <el-option
                  :value="2"
                  label="推广短信（0.055元/条）"
                >
                </el-option>
                <el-option
                  :value="1"
                  label="通知短信（0.045元/条）"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="dataForm.template_code"
                placeholder="请选择"
                style="margin-left: 16px;"
                @change="templateChange"
                clearable
              >
                <el-option
                  v-for="item in templateList"
                  :key="item.TemplateCode"
                  :label="item.TemplateName"
                  :value="{ value: item.TemplateCode, label: item.TemplateName,content:item.TemplateContent}"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              label="接收号码"
              prop="users"
            >
              <div class="check">
                已选择<span>{{users.length}}</span>个号码，
                <el-button
                  type="primary"
                  size="mini"
                  @click="userChooseDialog=true"
                >选择用户</el-button>
              </div>
              <div
                class="check"
                style="margin-top: 12px;"
                v-if="isInputUser"
              >
                已手动输入<span>{{inputUsers.length}}</span>个号码，
                <el-tag
                  v-for="(item,index) in inputUsers"
                  :key="index"
                  closable
                  :disable-transitions="false"
                  @close="handleToRemoveTag(index)"
                >
                  {{item}}
                </el-tag>
                <el-button
                  type="primary"
                  size="mini"
                  @click="addPhoneDialog=true"
                >输入号码</el-button>
              </div>
            </el-form-item>
            <el-form-item
              label="定时发送"
              prop="is_timer"
            >
              <el-switch
                v-model="is_timer"
                :active-value="1"
                :inactive-value="0"
              >
              </el-switch>
            </el-form-item>
            <el-form-item
              prop="do_time"
              v-if="is_timer==1"
            >
              <el-date-picker
                v-model="dataForm.do_time"
                type="datetime"
                clearable
                value-format="timestamp"
                placeholder="选择日期时间"
              >
              </el-date-picker>
              <div class="tips">如需撤销,请在发送时间前5分钟操作</div>
            </el-form-item>
          </el-form>
          <div class="line"></div>
          <div class="btn-wrap">
            <el-button
              type="primary"
              @click="submit('formRules')"
            >添加</el-button>
            <el-button @click="handleClose()">取消</el-button>
          </div>
        </div>
        <div class="preview">
          <div class="preview-content">
            <div class="pop">
              <span> {{ dataForm.TemplateContent }}</span>
            </div>
            <div class="tips">计费说明：当前约为<span>{{ dataForm.TemplateContent?dataForm.TemplateContent.length:0 }}</span>字，预计发送条数约为<span>{{ 1 }}</span>条（实际发送时，签名，变量长度回影响总字数）。</div>
          </div>
        </div>
      </div>
    </div>
    <MemberChoose
      :visible="userChooseDialog"
      @close="userChooseDialog = false"
      @submit="saveMember"
      :users="users"
    ></MemberChoose>
    <AddPhoneNumber
      :visible="addPhoneDialog"
      @close="addPhoneDialog = false"
      :users="inputUsers"
      @submit="AddPhoneNumberSubmit"
    ></AddPhoneNumber>
  </div>
</template>

<script>

import { smsTemplatelist, smsSignlist, smsSendTaskCreate } from "@/api/operation";
import MemberChoose from "@/components/dialog/member/MemberChoose"
import AddPhoneNumber from "@/components/dialog/groupmessage/AddPhoneNumber"

export default {
  components: {
    MemberChoose,
    AddPhoneNumber
  },
  data() {
    return {
      dataForm: {
        TemplateContent: '',
      },
      rules: {
        name: [{ required: true, message: "请输入任务名称", trigger: "blur" }],
        sign_name: [{ required: true, message: "请选择短信签名", trigger: "blur" }],
        template_code: [{ required: true, message: "请选择短信模板", trigger: "blur" }],
        do_time: [{ required: true, message: "请选择定时日期", trigger: "blur" }],
        users: [{
          required: true,
          validator: (rule, value, callback) => {
            if (this.users.length == 0 && this.inputUsers.length == 0) {
              callback(new Error('请选择或输入用户手机号'))
            } else {
              callback()
            }
          },
        }],
      },
      signList: [],
      variablelist: [],
      userChooseDialog: false,
      addPhoneDialog: false,
      users: [],
      templateList: [],
      smsSignList: [],
      TemplateType: '',
      isInputUser: true,
      inputUsers: [],
      is_timer: 0,
    };
  },
  created() {
    this.fetchTemplateList()
    this.fetchSignList()
  },

  methods: {
    fetchTemplateList() {
      smsTemplatelist({ TemplateType: this.TemplateType, isPging: 0, AuditStatus: 'AUDIT_STATE_PASS' }).then((res) => {
        this.templateList = res.list
      });
    },
    fetchSignList() {
      smsSignlist({ isPging: 0 }).then((res) => {
        this.smsSignList = res.list
      });
    },
    insertVar(variable) {
      let el = document.getElementById("textarea")
      let cursurPosition = -1

      if (el.selectionStart >= 0) {
        cursurPosition = el.selectionStart
      } else {
        let range = document.selection.createRange()
        cursurPosition = range.text.length
      }
      this.dataForm.TemplateContent = this.dataForm.TemplateContent.slice(0, cursurPosition) + '${' + variable + '}' + this.dataForm.TemplateContent.slice(cursurPosition)
    },
    handleClose() {
      this.$router.go(-1)
    },
    saveMember({ users }) {
      this.users = users
    },
    templateChange(e) {
      this.$set(this.dataForm, 'TemplateContent', e.content)
      if (e.content && e.content.indexOf('${') >= 0) {
        this.isInputUser = false
      } else {
        this.isInputUser = true
      }
    },
    AddPhoneNumberSubmit({ data }) {
      this.inputUsers = data
    },
    handleToRemoveTag(ind) {
      this.inputUsers.splice(ind, 1);
    },
    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          const data = {
            name: this.dataForm.name,
            sign_name: this.dataForm.sign_name,
            template_code: this.dataForm.template_code.value,
            is_timer: this.is_timer,
            do_time: this.is_timer == 1 ? this.dataForm.do_time : null,
            arr_uid: this.users.map(v => {
              return v.id
            }),
            arr_mobile_temp: this.isInputUser ? this.inputUsers : [],
          }
          smsSendTaskCreate(data).then((res) => {
            if (res == null) {
              this.handleClose()
              this.$message.success('创建成功')
            }
          })
        } else {

          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
  </script>
  
  <style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
    .main {
      height: 828px;
      display: flex;
      padding-top: 24px;

      .form {
        flex: 1;
        .link-wrap {
          margin-top: 8px;
          font-size: 14px;
          color: #999;
          .el-link {
            margin-right: 16px;
          }
        }
        .line {
          width: 730px;
          height: 1px;
          background: #eeeeee;
          border-radius: 0px 0px 0px 0px;
          opacity: 1;
        }
        .btn-wrap {
          margin-top: 16px;
        }
        .check {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          .el-link {
            margin-right: 12px;
          }
          .el-tag {
            margin: 0px 8px;
            margin-bottom: 8px;
          }
        }
        .tips {
          margin-top: 8px;
          font-size: 14px;
          font-weight: 400;
          color: #999999;
        }
      }
      .preview {
        flex: 1;
        display: flex;
        justify-content: center;
        .preview-content {
          width: 330px;
          height: 546px;
          background-image: url("https://upload.kaoyanbox.net/5b02efcfefeb534cae1ffe1ab8a88da0.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
          .pop {
            width: 224px;
            background: #e9e9eb;
            opacity: 1;
            min-height: 80px;
            border-radius: 16px;
            margin-top: 118px;
            padding: 9px 12px;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            margin-left: 43px;
            span {
              word-wrap: break-word;
            }
          }
          .tips {
            width: 261px;
            margin: 0 auto;
            margin-top: 40px;
            padding: 9px 12px;
            font-size: 14px;
            color: #666666;
            line-height: 22px;
            span {
              color: #e34d59;
              margin: 0px 4px;
            }
          }
        }
      }
    }
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }
}
/deep/.el-alert__icon {
  color: #266fe8;
}
/deep/.el-alert__title {
  color: #333;
}
</style>
  